import { render, staticRenderFns } from "./SelectedVehicleDetails.vue?vue&type=template&id=3e44a2b0"
import script from "./SelectedVehicleDetails.vue?vue&type=script&lang=js"
export * from "./SelectedVehicleDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports